module.exports = __webpack_public_path__ + "static/media/dynamic_schedules_preview.092052f8.PNG";